import VideoRewindOverlayIcon from '@atlaskit/icon-lab/core/video-rewind-overlay';
import * as React from 'react';

export function SvgRewind() {
  return <VideoRewindOverlayIcon label="" testId="ads-refreshed-icon" />;
}
